import Http from "./http";

export const updateAiCampaignAPI = (payload) => {
  return Http.post("admin/campaign/update", payload);
};
